import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Divider,
  Rating,
  //LinearProgress,
  CircularProgress,
} from '@mui/material';
import { Star } from '@mui/icons-material';

import { ModalRatings } from './ModalRatings';
import { trackEventMatomo } from 'js/library/utils/helpers';
import getRatings from 'js/library/utils/API/getRatings';
import { toast } from 'react-toastify';

import './stylesRating.css';

/* const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    width: "100%",
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "gold",
  },
}))(LinearProgress); */

export default function Ratings(item) {
  const { t } = useTranslation('app');

  const userInfo = item.userInfo;
  const establishmentInfo = item.establishmentInfo;

  const isGuest =
    item.userInfo === null ||
    item.userInfo.triiboId.indexOf('@guest-triibo.com.br') >= 0;

  //const [hover, setHover] = useState(-1);
  const [ratingNumber, setRatingNumber] = useState(0);
  const [userMessage, setUserMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [establishmentRatings, setEstablishmentRatings] = useState(null);

  useEffect(() => {
    getRatings(userInfo.uId, establishmentInfo.id)
      .then((result) => {
        const userAvaliation = result.establishmentInfo.ratings.filter(
          (item) => item.uid === userInfo.uId
        );
        if (userAvaliation.length > 0) {
          setRatingNumber(userAvaliation[0].rating);
          setUserMessage(userAvaliation[0].userComment);
        }
        setEstablishmentRatings(result.establishmentInfo);
      })
      .catch(() => {
        setEstablishmentRatings({ ratings: [], ratingsScore: {} });
      });
  }, [userInfo, establishmentInfo]);

  const handleRating = () => {
    if (ratingNumber === 0) {
      toast.warning(t('errors.avaliation_field_not_filled'));
    } else {
      trackEventMatomo('Estabelecimento', 'tocar', 'botao', 'Avaliar');

      if (isGuest) {
        item.checkAnonymous();
        return;
      }

      setOpen(true);
    }
  };

  const toggleModalRatings = () => {
    setOpen(false);
  };

  return (
    <div>
      {establishmentRatings ? (
        <>
          <div className="content-result-rating">
            {/* <section className="content-linear-progress">
          <div className="item-linear-progress">
            <span>5</span>
            <BorderLinearProgress variant="determinate" value={80} />
          </div>
          <div className="item-linear-progress">
            <span>4</span>
            <BorderLinearProgress variant="determinate" value={75} />
          </div>
          <div className="item-linear-progress">
            <span>3</span>
            <BorderLinearProgress variant="determinate" value={20} />
          </div>
          <div className="item-linear-progress">
            <span>2</span>
            <BorderLinearProgress variant="determinate" value={10} />
          </div>
          <div className="item-linear-progress">
            <span>1</span>
            <BorderLinearProgress variant="determinate" value={10} />
          </div>
        </section> */}

            <section className="content-number-starts">
              <div className="item-number-starts">
                {!establishmentRatings.ratingsScore.avg ? (
                  'Seja o primeiro a avaliar!'
                ) : (
                  <>
                    <span>{establishmentRatings.ratingsScore.avg}</span>
                    <Rating
                      name="read-only"
                      precision={0.5}
                      readOnly
                      style={{ fontSize: '20px' }}
                      value={establishmentRatings.ratingsScore.avg}
                    />
                  </>
                )}
              </div>
            </section>
          </div>

          <div className="area-rating">
            <Rating
              name="hover-feedback"
              style={{ fontSize: '2.5rem', color: 'gold' }}
              value={ratingNumber}
              precision={0.5}
              onChange={(_, newValue) => {
                setRatingNumber(newValue);
              }}
              /* onChangeActive={(_, newHover) => {
                setHover(newHover);
              }} */
              onTouchStart={(_, newValue) => {
                setRatingNumber(newValue);
              }}
            />
            <button
              type="button"
              className="button-rate"
              onClick={handleRating}
            >
              {t('general.rate')}
            </button>
          </div>

          <div>
            {establishmentRatings.ratings.map((item, index) => {
              return (
                <div key={index}>
                  <div className="area-message">
                    <div className="are-star">
                      <Star style={{ color: 'gold', fontSize: '3rem' }} />
                      <span className="number-star">{item.rating}</span>
                    </div>
                    <div className="item-message">
                      <i className="name-user">
                        {item.aliasName ? item.aliasName : 'Triiber'}
                      </i>
                      <i className="text-message">{item.userComment}</i>
                    </div>
                  </div>
                  <Divider style={{ float: 'right', width: '95%' }} />
                </div>
              );
            })}
          </div>

          <ModalRatings
            establishmentInfo={establishmentInfo}
            userInfo={userInfo}
            ratingNumber={ratingNumber}
            toggleModalRatings={toggleModalRatings}
            open={open}
            userMessage={userMessage}
          />
        </>
      ) : (
        <div style={{ textAlign: 'center' }} className="loading-content">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
